import { OrganisationMin } from 'models';

import { API_URL } from 'config';
import { makeAPICall } from './api';

export declare namespace API {
    export interface Satellite {
        id: number;
        organisation: OrganisationMin;
        name: string;
        description: string;
        enabled: boolean;
        created: string;
        is_visible: boolean;
        norad_name: string;
        catalogue_number: number;
    }
}

export interface Satellite {
    id: number;
    organisation: OrganisationMin;
    name: string;
    description: string;
    enabled: boolean;
    created: Date;
    is_visible: boolean;
    norad_name: string;
    catalogue_number: number;
}

const SATELLITES_ROUTE = '/satellites';

export const mapAPIToSatellite = ({
    created,
    ...rest
}: API.Satellite): Satellite => ({
    ...rest,
    created: new Date(created),
});

export const listSatellites = makeAPICall<
    Satellite[],
    void,
    { results: API.Satellite[] }
>(
    () => ({
        url: `${API_URL}${SATELLITES_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToSatellite),
);

export const getSatelliteById = makeAPICall<
    Satellite,
    { id: number },
    API.Satellite
>(
    ({ id }) => ({
        url: `${API_URL}${SATELLITES_ROUTE}/${id}/`,
    }),
    (satellite) => mapAPIToSatellite(satellite),
);
